import * as IoC from 'inversify';
import { registerQuery, registerCommand } from '@/app/tracking/common';
import { questionCommonTrackingModule } from '../common/di'
import { AnswerQuestionTrackingCommandName, QueryQuestionsTrackingQueryName } from '../api';
import { Scorm2004AnswerQuestionCommandHandler } from './scorm2004-answer-question-command-handler';
import { Scorm2004QueryQuestionsQueryHandler } from './scorm2004-query-questions-query-handler';
import { Scorm2004QuestionDataStore } from './scorm2004-question-data-store';

const questionScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(AnswerQuestionTrackingCommandName, Scorm2004AnswerQuestionCommandHandler, bind);
  registerQuery(QueryQuestionsTrackingQueryName, Scorm2004QueryQuestionsQueryHandler, bind);
  bind(Scorm2004QuestionDataStore).toSelf();
})

export const questionScorm2004TrackingModules = [
  questionCommonTrackingModule,
  questionScorm2004TrackingModule
]
